import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-show-add-trial-services-modal',
    templateUrl: './show-add-trial-services-modal.component.html',
    styleUrls: ['./show-add-trial-services-modal.component.scss'],
    imports: [MatButton, TranslatePipe]
})
export class ShowAddTrialServicesModalComponent {

  constructor(public dialogRef: MatDialogRef<ShowAddTrialServicesModalComponent>) { }

  /**
   * @function close will close the Modal
   */
  public close(): void {
    this.dialogRef.close();
  }
}
